import { api } from '../api/client';
import { getAppState } from '../app/index';
import { folderMemberWrapContextForInvite } from './shareLabel';
import { encodeBase64 } from './primitives';
import { wrapKeyForUser } from './pubKeyPinning';

export type SharedFolderMemberPermission = 'Read' | 'ReadWrite' | 'Full';

export async function inviteSharedFolderMember(input: {
  folderId: string;
  folderKey: Uint8Array;
  userId: string;
  permission: SharedFolderMemberPermission;
}): Promise<void> {
  const state = getAppState();
  if (state.kind !== 'authenticated') {
    throw new Error('not_authenticated');
  }

  const wrappedFolderKey = await wrapKeyForUser(
    input.userId,
    input.folderKey,
    folderMemberWrapContextForInvite(input.folderId),
    state.session.vaultVersion,
  );

  await api.inviteSharedFolderMember(input.folderId, {
    userId: input.userId,
    permission: input.permission,
    wrappedFolderKey: encodeBase64(wrappedFolderKey),
  });
}
